import { Box, Container, Typography } from '@mui/material';

const GiftWithUs = () => {
  return (
    <Box
      bgcolor="whitePepper.main"
      padding={{ xs: '30px 25px', md: '55px 50px 50px' }}
    >
      <Container maxWidth="xl" disableGutters>
        <Typography variant="h1" align="center" color="cinnamon.main">
          Why gift with us?
        </Typography>
        <Box
          sx={{ margin: '0 auto', maxWidth: '1120px' }}
          mt={{ xs: '20px', md: '30px' }}
        >
          <Typography
            variant="body1"
            align="center"
            color="garamMasala.main"
            mb={2}
          >
            There are few things that bring joy the way a plate of delicious
            food can. Combine that with the convenience of preparing it at home
            in just five minutes, and you’ve got a winner!
          </Typography>

          <Typography variant="body1" align="center" color="garamMasala.main">
            We at the Cumin Club bring you authentic Indian meals curated with
            love by expert regional chefs across India. Bring that joy to a
            special person in your life, and give the gift of food today!
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default GiftWithUs;
